import script from "./EndPc.vue?vue&type=script&setup=true&lang=js"
export * from "./EndPc.vue?vue&type=script&setup=true&lang=js"

import "./EndPc.vue?vue&type=style&index=0&id=246bf2b7&lang=scss&scoped=true"

import exportComponent from "D:\\psy\\项目\\guofang\\oldgfzs\\home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246bf2b7"]])

export default __exports__